
import { NodeConfig, TreeGraph, TreeGraphData } from '@antv/g6';
import { computed, defineComponent, reactive, ref, watch } from 'vue';
import { CustomNodeType } from './nodes';
import { renderTree } from './renderMap';
import {
  OioButton,
  OioDrawer,
  OioInputSearch,
  OioSpin,
  OioForm,
  OioFormItem,
  OioInput,
  OioInputNumber,
  OioSwitch,
  OioTextarea,
  OioDateTimePicker, OioRow, OioCol
} from '@kunlun/vue-ui-antd';

export default defineComponent({
  name: 'MindMap',
  components: {
    OioCol,
    OioRow,
    OioButton,
    OioDrawer,
    OioInputSearch,
    OioSpin,
    OioForm,
    OioFormItem,
    OioInput,
    OioInputNumber,
    OioSwitch,
    OioTextarea,
    OioDateTimePicker
  },
  props: ['treeData', 'merchBill','baseData'],
  setup(props) {
    const activeNode = ref<NodeConfig & Record<string, any>>();
    const treeGraph = ref<TreeGraph>();
    const showLinkModal = ref(false);
    const selectedLinkName = ref('');
    const showPolicyModal = ref(false);
    const showRightsSettingModal = ref(false);
    const isFullScreen = ref(false);
    const showLinkList = ref<any[]>([]);
    const showAdvanceSetting = computed(() => {
      if (
        activeNode.value?.type === CustomNodeType.RIGHTS_INFO &&
        activeNode.value?.jsonData.equityInformationRule.reductionOption === 'DISCOUNT_RATE'
      ) {
        return true;
      }
      return false;
    });

    const showRealPrice = computed(() => {
      return (
        [CustomNodeType.RIGHTS_INFO, CustomNodeType.SIMPLE_RIGHTS_INFO].includes(activeNode.value?.type ?? '') &&
        ['FULL_SUB'].includes(activeNode.value?.jsonData?.optionType ?? '')
      );
    });

    const showOnePrice = computed(() => {
      return (
        [CustomNodeType.RIGHTS_INFO, CustomNodeType.SIMPLE_RIGHTS_INFO].includes(activeNode.value?.type ?? '') &&
        ['FULL_SUB'].includes(activeNode.value?.jsonData?.optionType ?? '')
      );
    });

    const stopWatch = watch(
      () => props.treeData,
      (val) => {
        if (val) {
          setTimeout(() => {
            treeGraph.value = renderTree('mountNode', val);
            stopWatch();
          }, 500);
        }
      }
    );

    // 商品清单
    watch(
      () => props.merchBill,
      (val) => {
        showLinkList.value = val;
      },
      { deep: true }
    );

    watch(isFullScreen, (val) => {
      const ele = document.querySelector('#mountNode');
      if (ele) {
        // 进入全屏
        if (val) {
          ele.requestFullscreen().catch((err) => console.error(err));
          treeGraph.value!.setMode('custom');
        }
        // 退出全屏
        else {
          document.exitFullscreen();
          treeGraph.value!.setMode('default');
        }
      }
    });

    // ActionBar关联商品清单
    // @ts-ignore
    window.onActivityLinkProducts = (id) => {
      const node = treeGraph.value!.findDataById(id)! as TreeGraphData & Record<string, any>;
      activeNode.value = node;

      // 促销政策关联商品清单
      if (node.type === CustomNodeType.POLICY) {
        selectedLinkName.value = node.jsonData.promotionItemStr;
      }
      // 权益信息关联商品清单
      else if (node.type === CustomNodeType.RIGHTS_INFO) {
        selectedLinkName.value = node.jsonData.equityInformationRule.equityInfoItemStr;
      }

      showLinkModal.value = true;
      treeGraph.value!.layout();
    };

    // ActionBar设置
    // @ts-ignore
    window.onActivitySettings = (id) => {
      const node = treeGraph.value!.findDataById(id)! as TreeGraphData & Record<string, any>;
      activeNode.value = node;

      // 促销政策配置
      if (node.type === CustomNodeType.POLICY) {
        showPolicyModal.value = true;
      }
      // 权益信息配置
      else if ([CustomNodeType.RIGHTS_INFO, CustomNodeType.SIMPLE_RIGHTS_INFO].includes(node.type)) {
        showRightsSettingModal.value = true;
      }
    };

    // 前置条件关联商品清单打开弹窗
    // @ts-ignore
    window.onActivityRuleLinkProducts = (id, index) => {
      const node = treeGraph.value!.findDataById(id)! as TreeGraphData & Record<string, any>;
      activeNode.value = node;
      selectedLinkName.value = node.jsonData.conditions[index].promotionItemStr;

      showLinkModal.value = true;
    };

    return {
      activeNode,
      showLinkModal,
      selectedLinkName,
      showPolicyModal,
      showRightsSettingModal,
      isFullScreen,
      showLinkList,
      showAdvanceSetting,
      showRealPrice,
      showOnePrice
    };
  }
});
